<template>
<section class="company-advanced">
    <div class="company-products-box w">
        <!-- topProducts.length === 4 || topProducts.length === 8 -->
        <template v-if="false">
        <div class="company-products-item" v-for="item in topProducts" @click="toProductDetail(item.goodsId)">
            <el-image :src="item.goodsThumbnail"></el-image>
            <div class="company-products-info">
                <div class="company-products-name">
                    {{ item.goodsName }}
                </div>
                <div class="company-products-price">
                    ￥{{ productPrice(item.goodsPriceType, item.goodsPrice) }}</div>
            </div>
        </div>
        </template>
    </div>
    <div class="company-advanced-display w" v-html="shopData.decoration"></div>
</section>
</template>

<script>
export default {
    props: {
        shopData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            topProducts: []
        }
    },
    mounted() {
        this.getTopProducts()
    },
    computed: {
        productPrice() {
            return (type, price) => {
                if(type === 2) return '面议';
                else if(type === 3) return '免费';
                else return Number(price).toFixed(2)
            }
        }
    },
    methods: {
        getTopProducts() {
            this.$http.post(this.$const.RemoteSensingMall.requestShopAllProduct, {
                shopId: this.shopData.id,
                pageNum: 1, pageSize: 8, type: 2, orderType: 2
            }).then(res => {
                if(res.code === 200) {
                    this.topProducts = res.data.list
                }
            }).catch(error => {
                console.log(error)
                this.$message.error('请求商家商品错误！');
            })
        },
        toProductDetail(id) {
            this.$router.push({ name: "productDetail", params: { id: id}})
        }
    }
}
</script>

<style lang="scss" scoped>
.company-advanced {

    > .company-products-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 1%;

        > .el-empty {
            margin: 0 auto;
        }

        > .company-products-item {
            flex: 0 0 24%;
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;
            transition: .2s;
            overflow: hidden;
            cursor: pointer;

            &:hover {
                box-shadow: 0px 0px 12px rgba(37, 105, 242, .1);
            }
            > .el-image {
                width: 100%;
                height: 240px;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
            }
            > .company-products-info {
                height: 118px;
                padding: 20px;
                background-color: white;
                border-bottom-left-radius: 6px;
                border-bottom-right-radius: 6px;
                font-size: 18px;
                font-weight: 600;

                > .company-products-name {
                    width: 100%;
                    height: 48px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                > .company-products-price {
                    margin-top: 10px;
                    color: #BD4444;
                }
            }
        }
    }
    > .company-advanced-display {
        // width: 100%;
        overflow-x: hidden;
    }
}
</style>